import { ChainType } from '@apeiron/temp'
import { TradeParty } from '@src/types/trade'

export enum TradeType {
  Buy = 0,
  CancelSell,
  Sell,
  Gift
}

export enum TradeState {
  HIDING_POPUP = 0, // default
  SHOWING_POPUP, // show popup
  APPROVING, // show approval loading
  OPERATING, // show buying, selling, gifting loading
  SHOWING_SUCCESS_POPUP, // show success popup
  ALREADY_DONE // show operation already done when revisit
}

export enum SaleMethodType {
  FixedPrice = 'fixed_price',
  Auction = 'auction'
}

export enum TradePartyType {
  Apeiron = 'apeiron',
  SkyMavis = 'sky_mavis'
}

export const SKIP_QUANTITY = -1

export const TRADE_PART_MAP: Partial<Record<ChainType, TradeParty[]>> = {
  [ChainType.Ronin]: [
    {
      type: TradePartyType.Apeiron,
      fee: 4.5
    },
    {
      type: TradePartyType.SkyMavis,
      fee: 2.5
    }
  ],
  [ChainType.RoninTestnet]: [
    {
      type: TradePartyType.Apeiron,
      fee: 4.5
    },
    {
      type: TradePartyType.SkyMavis,
      fee: 2.5
    }
  ],
  [ChainType.Polygon]: [
    {
      type: TradePartyType.Apeiron,
      fee: 4.5
    }
  ],
  [ChainType.PolygonTestnet]: [
    {
      type: TradePartyType.Apeiron,
      fee: 4.5
    }
  ]
}
